import { c as _c } from "react/compiler-runtime";
import { IcoForbid40 } from '@onefootprint/icons';
import { EmptyState } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { NavigationHeader } from '../../../layout';
type ErrorProps = {
  resetErrorBoundary: () => void;
};
const ErrorComponent = t0 => {
  const $ = _c(15);
  const {
    resetErrorBoundary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.errors.uncaught-error"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp2);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp3);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== resetErrorBoundary || $[9] !== t5) {
    t6 = {
      label: t5,
      onClick: resetErrorBoundary
    };
    $[8] = resetErrorBoundary;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t6) {
    t7 = <>{t2}<EmptyState description={t3} iconComponent={IcoForbid40} title={t4} cta={t6} /></>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default ErrorComponent;
function _temp($) {
  return $.description;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.cta;
}